var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.infoAnalise &&
    _vm.infoAnalise.despacho &&
    _vm.dadosCertificacao &&
    _vm.infoAnalise.protocolo &&
    _vm.infoAnalise.numeroProcesso
    ? _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "flex-row gap-2 mt-15px" },
            [
              _c(
                "el-button",
                {
                  staticClass: "flex-center w-45px h-30px",
                  attrs: { type: "primary" },
                  on: { click: _vm.voltar }
                },
                [_c("i", { staticClass: "fas fa-chevron-left" })]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "font-20px font-weight-600" }, [
                _vm._v("Voltar")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.infoAnalise &&
          _vm.infoAnalise.protocolo &&
          _vm.infoAnalise.numeroProcesso
            ? _c("visualizar-cadastro", {
                attrs: {
                  protocolo: _vm.infoAnalise.protocolo,
                  cadastroContainerCustomClasses:
                    "card border-radius-4px bg-light-grey"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tipo-processo mt-3" },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.alterarTipoAcao },
                  model: {
                    value: _vm.tipoAcao,
                    callback: function($$v) {
                      _vm.tipoAcao = $$v
                    },
                    expression: "tipoAcao"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "despacho" } }, [
                    _vm._v("Despacho")
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "certificacao" } }, [
                    _vm._v("Emitir Certificado")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isDespacho
            ? _c(
                "div",
                [
                  _c(
                    "el-card",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "validation-observer",
                        { ref: "observer" },
                        [
                          _c("input-text-editor", {
                            attrs: {
                              label: "Despacho",
                              validationRules: "required"
                            },
                            model: {
                              value: _vm.infoAnalise.despacho.texto,
                              callback: function($$v) {
                                _vm.$set(_vm.infoAnalise.despacho, "texto", $$v)
                              },
                              expression: "infoAnalise.despacho.texto"
                            }
                          }),
                          _vm._v(" "),
                          _c("document-upload", {
                            attrs: {
                              id: "anexos-despacho",
                              files: _vm.infoAnalise.despacho.documentos
                            },
                            on: {
                              uploadFile: _vm.uploadFile,
                              removeFile: _vm.removeFile
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mt-3 mb-1 flex-center" },
                            [
                              _vm.acoesDespacho && _vm.acoesDespacho.length
                                ? _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.acaoSelecionada,
                                        callback: function($$v) {
                                          _vm.acaoSelecionada = $$v
                                        },
                                        expression: "acaoSelecionada"
                                      }
                                    },
                                    _vm._l(_vm.acoesDespacho, function(acao) {
                                      return _c(
                                        "el-radio",
                                        {
                                          key: acao.id,
                                          attrs: { label: acao.id }
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(acao.nome) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm.isCertificacao
            ? _c(
                "div",
                [
                  _c("certificacao-processo", {
                    ref: "certificacaoProcesso",
                    attrs: {
                      dadosCertificacao: _vm.dadosCertificacao,
                      textoCertificado: _vm.textoCertificado,
                      etapaAtual: _vm.etapaAtual,
                      etapasCompletas: _vm.etapasCompletas,
                      certificadoGerado: _vm.certificadoGerado,
                      loadingCertificado: _vm.loadingCertificado
                    },
                    on: {
                      dadosAlterados: _vm.receberDadosAlterados,
                      textoAlterado: _vm.receberTextoAlterado
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isDespacho
            ? _c("app-buttons-cadastro-sicarf", {
                attrs: {
                  isIntroPasso: false,
                  isPrimeiroPasso: _vm.isPrimeiroPasso,
                  isUltimoPasso: _vm.isUltimoPasso,
                  showButtonCancelar: _vm.showButtonCancelar,
                  showButtonProximo: _vm.showButtonProximo,
                  showButtonSalvar: _vm.showButtonSalvar
                },
                on: {
                  salvar: _vm.salvar,
                  cancelar: _vm.cancelar,
                  finalizar: _vm.finalizar
                }
              })
            : _vm.isCertificacao
            ? _c("app-buttons-cadastro-sicarf", {
                attrs: {
                  isIntroPasso: false,
                  isPrimeiroPasso: _vm.etapaAtual === 1,
                  isUltimoPasso: _vm.etapaAtual === 3,
                  showButtonCancelar: true,
                  showButtonSalvar: _vm.etapaAtual === 1 || _vm.etapaAtual === 2
                },
                on: {
                  salvar: _vm.salvarCertificacao,
                  cancelar: _vm.cancelar,
                  voltar: _vm.voltarCertificacao,
                  proximo: _vm.proximo,
                  finalizar: _vm.finalizarCertificacao
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24ae9b05", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ae9b05","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/analise/certificacao/emissao-certificado/emissao-certificado.vue
// module id = null
// module chunks = 